export default __webpack_public_path__ + "static/media/adidas.fe801360.png";